import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "AppMode";
const CHANGE_EVENT = "appmodechange";

export const SEEKER = "seeker";
export const RECRUITER = "recruiter";

export function getAppMode() {
  const stored = window.sessionStorage.getItem(STORAGE_KEY);
  return stored === RECRUITER ? RECRUITER : SEEKER;
}

export function setAppMode(mode) {
  const next = mode === RECRUITER ? RECRUITER : SEEKER;
  window.sessionStorage.setItem(STORAGE_KEY, next);
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: next }));
  return next;
}

/**
 * Seeker/recruiter mode is a view preference, never an authorization decision —
 * the API scopes every recruiter response by EmployerAccess regardless of mode.
 */
export default function useAppMode() {
  const [mode, setMode] = useState(getAppMode);

  useEffect(() => {
    const onChange = () => setMode(getAppMode());
    window.addEventListener(CHANGE_EVENT, onChange);
    return () => window.removeEventListener(CHANGE_EVENT, onChange);
  }, []);

  const change = useCallback((next) => setMode(setAppMode(next)), []);

  return [mode, change];
}
